var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 730.96 676.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-dasharray: 10 10;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #435d78;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #435d79;\n        font-family: Monaco, Monaco;\n        font-size: 8px;\n        letter-spacing: -.02em;\n      }\n\n      .cls-4 {\n        fill: #435d78;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 63.18,
    y: 63.83,
    width: 548.89,
    height: 548.89
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.18 63.83 209.67 210.32 465.59 466.23 612.08 612.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "612.08 63.83 465.59 210.32 209.67 466.23 63.18 612.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: ".5 383.44 63.18 383.44 63.18 293.11 .5 293.11 .5 338.27 .5 383.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.18,
    y1: 338.27,
    x2: 0.5,
    y2: 338.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "612.08 383.44 674.76 383.44 674.76 293.11 612.08 293.11 612.08 338.27 612.08 383.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 674.76,
    y1: 338.27,
    x2: 612.08,
    y2: 338.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "382.8 63.18 382.8 .5 292.46 .5 292.46 63.18 337.63 63.18 382.8 63.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 337.63,
    y1: 0.5,
    x2: 337.63,
    y2: 63.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "382.8 676.1 382.8 613.42 292.46 613.42 292.46 676.1 337.63 676.1 382.8 676.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 337.63,
    y1: 613.42,
    x2: 337.63,
    y2: 676.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "136.43 477.54 136.43 364.22 94.76 364.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "98.07 360.13 98.76 360.86 95.14 364.22 98.76 367.58 98.07 368.31 93.68 364.22 98.07 360.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "136.43 199.85 136.43 313.17 94.76 313.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "98.07 309.08 98.76 309.82 95.14 313.17 98.76 316.53 98.07 317.26 93.68 313.17 98.07 309.08"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "528.5 477.54 528.5 364.22 570.16 364.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "566.85 368.31 566.17 367.58 569.78 364.22 566.17 360.86 566.85 360.13 571.25 364.22 566.85 368.31"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "528.5 199.85 528.5 313.17 570.16 313.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "566.85 317.26 566.17 316.53 569.78 313.18 566.17 309.82 566.85 309.09 571.25 313.18 566.85 317.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "473.31 534.2 359.98 534.2 359.98 575.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "355.9 572.55 356.63 571.87 359.98 575.48 363.34 571.87 364.07 572.55 359.98 576.95 355.9 572.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "195.62 534.2 308.94 534.2 308.94 575.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "304.85 572.55 305.58 571.87 308.94 575.48 312.3 571.87 313.03 572.55 308.94 576.95 304.85 572.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "473.31 142.12 359.98 142.12 359.98 100.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "364.07 103.77 363.34 104.45 359.99 100.84 356.63 104.45 355.9 103.77 359.99 99.37 364.07 103.77"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "195.62 142.12 308.94 142.12 308.94 100.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "313.03 103.77 312.3 104.45 308.94 100.84 305.58 104.45 304.85 103.77 308.94 99.37 313.03 103.77"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 722.58,
    y1: 64.33,
    x2: 722.58,
    y2: 612.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 719.33,
    y: 63.83,
    width: 6.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 719.33,
    y: 612.42,
    width: 6.5,
    height: 1
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(716.88 55.31)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "46\u2019"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprint);
export default __webpack_public_path__ + "static/media/blueprint.7dbeba9ed0adcb3f5f811ed2c3b4a019.svg";
export { ForwardRef as ReactComponent };